
import { JobDetailedStop } from '@/models/jobDetailed';
import { Component, Prop, Vue } from 'vue-property-decorator';
import DateTimezoneToggle from '@/components/UI/dateTimezoneToggle/DateTimezoneToggle.vue';
import StopServices from '@/components/jobDetailed/StopServices.vue';
import store from '@/store';

@Component({
  components: {
    DateTimezoneToggle,
    StopServices,
  },
})
export default class Stop extends Vue {
  @Prop({ type: Object, required: true }) private readonly stop!: JobDetailedStop;
  @Prop({ type: String }) private readonly state!: string;

  public getDriverData(id: number) {
    const driverList = store.getters['moduleStaticData/getDrivers'];
    const driver = driverList.find(x => x.code === id);
    return driver?.full_name || 'No name';
  }
}
